import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import TableLayout from '../../../TableLayout';
import MessageHistoryFilterComponent from '../filter/MessageHistoryFilterComponent';
import AutoMessageHistoryTableComponent from './MessageHistoryTableComponent';
import { MenuList, RecipentList, keywordTypeList } from '../filter/MessageHistoryFilterComponent';
import { ICustomerInfo } from 'pages/Message/Manual/ManualStore';
import { useHistoryRequestParams, IRequestParams } from '../../HistoryStore';
import { getMessageAutoHistory, getMessageManualHistory, IResponseGetMessageManualHistory } from 'pages/Message/api';
import { dtoManualHistory, dtoAutoHistory } from 'pages/Message/dto';

export interface IHistoryTableDataAuto {
  messageId: string; // 메시지 ID
  sendDate: string; // 발송일
  recipentType?: string; // 수신인 종류
  title: string; // 제목
  recipant_name: string; // 수신인 이름
  contents: string; // 내용
  recipent_infos: ICustomerInfo[]; // 수신인 정보목록
  send_status?: string; // 발송상태
  // 추가 정보
  teamId?: number | null; // 팀 ID
  requestId?: number | string | null; //
  createdBy?: string | null; //
  updatedAt?: string | null; //
  createdAt?: string | null; //
  updatedBy?: string | null; //
  // 수동 처리관련
  sendMode?: boolean; // 수정하기 버튼 보여주기 여부
  receiverType?: string | null; // 'driver' | 'client'
  // 제외 처리 관련
  exceptionStartTime?: string | null; // 00:00-23:59
  exceptionEndTime?: string | null; // 00:00-23:59
}

const tempFetch = async (params: IRequestParams) => {
  const startDate = dayjs(params.startDate).format('YYYYMMDD');
  const endDate = dayjs(params.endDate).format('YYYYMMDD');
  let requestParams: {
    sendDatetime: string;
    type?: string;
    keyword?: string;
    isException?: boolean;
    receiverType?: string;
  } = {
    sendDatetime: `${startDate}-${endDate}`,
  };
  if (params?.keyword && params.keyword.length > 0) {
    requestParams = {
      ...requestParams,
      type: params.keywordType,
      keyword: params.keyword,
    };
  }
  if (params.tabType === 'MANUAL_MESSAGE') {
    const manualData = await getMessageManualHistory(requestParams);
    return dtoManualHistory(manualData);
  } else {
    requestParams = {
      ...requestParams,
      receiverType: params.recipentType,
    };
    if (params.tabType === 'EXCEPTION_MESSAGE') {
      requestParams = {
        ...requestParams,
        isException: true,
      };
    }
    const autoData = await getMessageAutoHistory(requestParams);
    return dtoAutoHistory(autoData);
  }
};

export default function HistoryTable() {
  const { requestParams } = useHistoryRequestParams();

  const { isFetching, data } = useQuery(['historyDataList', requestParams], () => tempFetch(requestParams), {
    onSuccess: res => {},
    enabled: !!requestParams,
  });

  return (
    <TableLayout title="발송 이력 조회" desc="고객에게 메시지를 발송/예약한 내역을 확인할 수 있습니다.">
      <MessageHistoryFilterComponent />
      <AutoMessageHistoryTableComponent data={data ?? []} isFetching={isFetching} />
    </TableLayout>
  );
}
